interface FooterColumn {
  title: string;
  links: string[];
}

const columns: FooterColumn[] = [
  {
    title: 'FEATURES',
    links: ['Payroll Automation', 'NIB Compliance', 'Salary Calculator', 'Direct Deposit'],
  },
  {
    title: 'LEARN',
    links: ['Small Biz Blog', 'Help Center', 'Tax Tips', 'Community'],
  },
  {
    title: 'TRUST',
    links: ['Privacy Policy', 'Data Security', 'Contact Support', 'About Us'],
  },
];

export function LandingFooter() {
  return (
    <footer className="bg-slate-800 px-16 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr] gap-16">
      {/* Brand Column */}
      <div>
        <div className="font-display text-2xl font-bold text-white mb-4">
          Paradigm.
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          Making business finances feel like a breeze. Join the modern payroll
          revolution today.
        </p>
      </div>

      {/* Link Columns */}
      {columns.map((col) => (
        <div key={col.title}>
          <h4 className="font-bold text-sm text-slate-300 mb-6">
            {col.title}
          </h4>
          <ul className="space-y-3">
            {col.links.map((link) => (
              <li
                key={link}
                className="text-[0.95rem] text-slate-400 cursor-pointer hover:text-accent-teal transition-colors"
              >
                {link}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </footer>
  );
}
